import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {SportTypeEmptyStateSportsImageRequestParams} from "./assest/sport-type-empty-state-sports-image-request.params";
import {SCORES_EMPTY_STATE} from "../scores-placeholder.const";
import {SportTypeIcon} from "../../../icons/sportType/sport-type-icon";

export class SportTypeEmptyStateComponentProps extends BaseProps {
  sportTypeId: Array<Number>;
  text: String;
  isSmallView: Boolean;
}

export const SportTypeEmptyState = (props: SportTypeEmptyStateComponentProps) => {
  const imageProps = {
    id: props.sportTypeId,
    className: 'scores-empty-state-logo-container',
    src: new SportTypeEmptyStateSportsImageRequestParams(
      SCORES_EMPTY_STATE.LOGO_SIZE,
      SCORES_EMPTY_STATE.LOGO_SIZE,
    )
  }

  return (
    <div
      className={['scores-empty-state', props.className, props.isSmallView ? 'scores-empty-state-small-view' : ''].join(' ')}>
      <SportTypeIcon {...imageProps}/>
      <div className={'scores-empty-state-text-container'}>
        {props.text}
      </div>
    </div>
  )
}
